// extracted by mini-css-extract-plugin
export default {"rnFooterContainer":"FooterContainer_rnFooterContainer__IMR5g"};